// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".THDrg{margin:0 .25rem;white-space:nowrap}._fMz3{min-width:16px;min-width:1rem}._2sHt-{width:240px;width:15rem}@media(max-width:767px){._2sHt-{width:100%}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"text": "THDrg",
	"icon": "_fMz3",
	"dropdownItem": "_2sHt-"
};
module.exports = exports;
